export const _ticketFr = {
    title: 'Message d\'alerte NEXSIMU RP pour le centre',
    adress: 'ADRESSE',
    vehicle: 'ENGIN',
    vehicles: 'ENGINS DEJA ENGAGES',
};

export const _ticketEn = {
    title: 'NEXSIMU RP alert message for the center',
    adress: 'ADDRESS',
    vehicle: 'VEHICLE',
    vehicles: 'VEHICLES ALREADY ENGAGED',
};

export const _ticketDe = {
    title: 'NEXSIMU RP Alarmmeldung für das Zentrum',
    adress: 'ADRESSE',
    vehicle: 'FAHRZEUG',
    vehicles: 'BEREITS EINGESETZTE FAHRZEUGE',
};
